<template>
  <div id="booking_images" v-if="hasImages" v-on:mouseover="mouseHover" v-on:mouseout="mouseOut">

    <div id="viewServiceImage_carousel" class="carousel slide image_slider" data-bs-ride="carousel" >
      <!-- Small Dotes Found in the below of the images     -->
      <div v-if="images.length != 1" class="carousel-indicators ">
        <button type="button" v-for="(image, index ) in images" :key="index" data-bs-target="#viewServiceImage_carousel" :data-bs-slide-to="index" :class="((index == 0) ? 'active' : '')" aria-current="true" aria-label="Slide 1"></button>
      </div>

      <!--           images Section -->
      <div class="carousel-inner">

        <span id="images_count" v-if="!needZeroSpan">
            <i class="fa fa-camera"></i>
          <span class="image_count_span"  >{{imagesCount}} </span>
<!--          <span class="image_count_span"  > <span v-if="needZeroSpan" >0</span>{{imagesCount}} </span>-->
        </span>
        <span id="images_count_without_zero" v-if="needZeroSpan">
            <i class="fa fa-camera"></i>
          <span class="image_count_span"  >{{imagesCount}} </span>
<!--          <span class="image_count_span"  > <span v-if="needZeroSpan" >0</span>{{imagesCount}} </span>-->
        </span>

        <div v-for="(image, index ) in images" :key="index" :class="'carousel-item '+ ((index == 0 ) ? 'active' : '')">
          <div>
            <a  data-toggle="modal" data-target="#fn_nearest" :onclick="image.popupURL">
                <img  :src="image.image_src"  style='width:100%;' />
            </a>
          </div>
          <div class="carousel-caption d-none d-md-block">
            <h5></h5>
            <p></p>
          </div>
        </div>
      </div>

      <!--    Prev and Next Buttons       -->
      <button v-if="images.length != 1" class="carousel-control-prev hidden" type="button" data-bs-target="#viewServiceImage_carousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden"></span>
      </button>
      <button v-if="images.length != 1" class="carousel-control-next hidden" type="button" data-bs-target="#viewServiceImage_carousel" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden"></span>
      </button>
    </div>

  </div>

</template>


<script>
import {Carousel} from "bootstrap/js/src/carousel"
import {getBookingImages} from "@/modules/CustomerPortal/api/bookings/view";

export default {
  name: "BookingViewImages",
  components: {getBookingImages},
  props: [
    "booking_id",
    "company_name",
    "company_id"
  ],
  data() {
    return {
      images: [],
      imagesArr: [],
      hasImages: 0,
      imagesCount: 0,
      needZeroSpan: 1,
    }
  },
  methods:{
    mouseHover : function viewClasses(){
      if(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))){
        // true for mobile device
        $(".carousel-control-prev").removeClass('hidden');
        $(".carousel-control-next").removeClass('hidden');
        // $(".carousel-indicators").removeClass('hidden');
      }

    },
    mouseOut : function hideClasses(){
      if(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))){
        $(".carousel-control-prev").addClass('hidden');
        $(".carousel-control-next").addClass('hidden');
        // $(".carousel-indicators").addClass('hidden');
      }
    }
  },
  computed: {


  },
  mounted(){
    getBookingImages(this.booking_id, this.company_name, this.company_id).then((response) => {
      if(response.status == 200){
        if(response.data.type == 'success'){
          this.images = response.data.data.images;
          this.imagesArr = response.data.data.imagesArr;
          this.hasImages = (this.images.length) ? 1 : 0 ;
          this.imagesCount = response.data.data.imagesCount;
          this.needZeroSpan = response.data.data.needZeroSpan;
        }
      }
      return response
    }).then((response) => {
      if((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))){
        // true for mobile device
        $(".carousel-control-prev").removeClass('hidden');
        $(".carousel-control-next").removeClass('hidden');
        // $(".carousel-indicators").removeClass('hidden');
      }
    });

  }
}



</script>

<style scoped>

@media (max-width: 1080px){
  #images_count{
    left: 68% !important;
  }

  #images_count_without_zero{
    left: 68% !important;

  }
}
@media (max-width: 960px){
  #images_count{
    top: 81% !important;;
    left: 79% !important;;
  }

  #images_count_without_zero{
    top: 81% !important;;
    left: 82% !important;;
  }

}


@media (max-width: 540px){
  #images_count{
    top: 51% !important;;
    left: 74% !important;;
    width: 80px !important;;
    height: 47px !important;;
  }
  #images_count .fa-camera{
    font-size: 29px !important;;
    top: 11px !important;;
  }

  #images_count span{
    top: 8px !important;
    font-size: 23px !important;;
    left: 47px !important;;
  }

  #images_count_without_zero {
    top: 51% !important;;
    left: 76% !important;;
    width: 80px !important;;
    height: 47px !important;;
  }
  #images_count_without_zero  .fa-camera{
    font-size: 29px !important;;
    top: 11px !important;
    left: 15% !important;
  }

  #images_count_without_zero span{
    top: 8px !important;
    font-size: 23px !important;;
    left: 67% !important;;
  }
}



#images_count{
  width: 100px;
  height: 60px;
  display: block;
  background: rgba(255,255,255,0.8);
  /*background: #FFF;*/
  position: absolute;
  z-index: 1000;
  top: 80%;
  left: 85%;
  border-radius: 7px;
  /*box-shadow: 0px 0px 2px #000;*/
  padding: 0% 5%;

}
#images_count .fa-camera{
  font-size: 35px;
  top: 12px;
  position: absolute;
  left: 11px;
  color: #0071be;
}
#images_count .image_count_span{
  position: absolute;
  top: 7px;
  font-size: 30px;
  font-weight: 35px;
  left: 57px;
}

#images_count_without_zero {
  width: 100px;
  height: 60px;
  display: block;
  background: rgba(255,255,255,0.8);
  /*background: #FFF;*/
  position: absolute;
  z-index: 1000;
  top: 80%;
  left: 85%;
  border-radius: 7px;
  /*box-shadow: 0px 0px 2px #000;*/
  padding: 0% 5%;

}
#images_count_without_zero  .fa-camera{
  font-size: 35px;
  top: 12px;
  position: absolute;
  left: 17px;
  color: #0071be;
}
#images_count_without_zero  .image_count_span{
  position: absolute;
  top: 7px;
  font-size: 30px;
  font-weight: 35px;
  left: 68px;
}

#booking_images{
  margin-top: 20px;
}

img,a {
  display: block;
  vertical-align: middle;
  width: 100%;
  object-fit: cover;
  height: 470px !important
}

.img-responsive{
  border-radius: 0% !important;
}

.carousel {
  position: relative;
  height: inherit;
  clear: both;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
  clear: both;
}

.carousel-inner > .carousel-item {
  position: relative;
  display: none;
  animation: 0.6s ease-in-out;
  height: 40%; /* Set your height */
}

.carousel-item > .carousel-img {
  width: 100%;
  height: 50%; /* same height */
  height: auto;
}

.carousel-item.carousel-video {
  display: block;
  object-fit: cover;
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 0;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  /* uncomment the following line if you want to prevent mouse (or touch) clicks */
  /* pointer-events: none; */
}
.carousel-inner>.active,
.carousel-inner>.next {
  display: block;
}

.carousel-inner>.next {
  position: absolute;
  top: 0;
  width: 100%;
}

.carousel-inner>.to-left {
  animation-name: left;
}

.carousel-inner>.from-right {
  animation-name: right;
}

.carousel-inner>.to-right {
  animation-name: right;
  animation-direction: reverse;
}

.carousel-inner>.from-left {
  animation-name: left;
  animation-direction: reverse;
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  bottom: 0;
  z-index: 1;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  transition: opacity 0.15s ease;
  height: 6%;
  /* background-color: white; */
  width: 6%;
  top: 50%;
  border: #fff;
  border-radius: 2px;
  /*top: 50%;*/
}

.carousel-control {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 15%;
  cursor: pointer;
}

@media screen and(max-width: 540px){
  .carousel-control-prev,
  .carousel-control-next {
    position: absolute;
    bottom: 0;
    z-index: 1;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    opacity: 0.5;
    transition: opacity 0.15s ease;
    height: 5%;
    /* background-color: white; */
    width: 4.5%;
    top: calc(50%);
  }

  .carousel-indicators{
    top: calc(50% - 50px);
  }
}
.carousel-inner > .carousel-item .slider_thumb{
  width: 100%;
  /* or any custom size */
  height: 100%;
  object-fit: contain;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
    width: 8.5%;
  }
}

@media (max-width: 768px) {
  .carousel-indicators {
    /*bottom: 25px;*/
  }
  .carousel-control-prev,
  .carousel-control-next {
    width: 8.5%;
    height: 10%;
    top:30%;
  }

  img {

    height: 300px !important
  }


}

/*.carousel-control-prev:hover,*/
/*.carousel-control-prev:focus,*/
/*.carousel-control-next:hover,*/
/*.carousel-control-next:focus {*/
/*  color: #fff;*/
/*  text-decoration: none;*/
/*  outline: 0;*/
/*  opacity: 0.9;*/
/*}*/

.carousel-control-prev {
  left: 10px;
}

.carousel-control-next {
  right: 10px;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50% / 100% 100%;
  border: 0px;
}

.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' width='4' height='4' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e");
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' width='4' height='4' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e");
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.carousel-indicators .active {
  background-color: white !important;
  border-color: white !important;
  opacity: 1 !important;
}
.carousel-indicators >button {
  width: 12px !important;
  height: 12px !important;
  border-radius: 100% !important;
  border-color: white !important;
  background-color: #FFFFFF !important;
  opacity: 0.4 !important;
  border-width: 0px;
  margin: 0 5px;
}
.carousel-indicators{
  top: 20px !important;
  /*left:30%*/
  padding-right: 30%;
}


/*@keyframes left {*/
/*  from {*/
/*    left: 0;*/
/*  }*/
/*  to {*/
/*    left: -100%;*/
/*  }*/
/*}*/

/*@keyframes right {*/
/*  from {*/
/*    left: 100%;*/
/*  }*/
/*  to {*/
/*    left: 0;*/
/*  }*/
/*}*/


.carousel-indicators{
  position: absolute;
  bottom: unset;
  left: auto;
  z-index: 15;
  padding: 0;
  width: 100%;
  margin-left: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: flex-start;
}
</style>
